/* Rosery theme scripts (moved out of layout/theme.liquid).
   Loaded with defer after Swiper. Everything here is plain JS with no Liquid. */

/* 1. Product-card image swipers ------------------------------------------- */
(function () {
  function init() {
    if (typeof Swiper === 'undefined') return;
    var swipers = [];
    document.querySelectorAll('.product-swiper').forEach(function (el) {
      if (el.dataset.roserySwiper) return;
      el.dataset.roserySwiper = '1';
      var s = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        pagination: {
          el: el.querySelector('.custom-swiper-pagination'),
          type: 'bullets',
          clickable: true,
          bulletClass: 'custom-bullet',
          bulletActiveClass: 'custom-bullet-active'
        },
        on: {
          touchStart: function () {
            var self = this;
            swipers.forEach(function (o) {
              if (o !== self && o.activeIndex !== 0) o.slideTo(0, 300);
            });
          }
        }
      });
      swipers.push(s);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* 2. One-tap add for .variant-button (used by custom blocks) ---------------- */
(function () {
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('.variant-button');
    if (!btn) return;
    e.preventDefault();
    try {
      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      }));
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: btn.value, quantity: 1, sections: sectionsToBundle.join(',') })
      });
      if (!response.ok) return;
      var addedItem = await response.json();
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart: addedItem, onSuccessDo: 'force_open_drawer' }
      }));
    } catch (err) {}
  });
})();

/* 3. REMOVED - forced pinch-zoom.

   This used to walk every element in the page and rewrite touch-action to
   'pan-x pan-y pinch-zoom'. The side effect was that a two-finger scroll
   zoomed the page by accident. Pinch zoom still works through the viewport
   meta; it is just not forced onto every element.
   ------------------------------------------------------------------------- */

/* 4. Hide the Webyze color label even when it loads late ------------------- */
(function () {
  function run() {
    var tries = 0;
    var iv = setInterval(function () {
      var label = document.querySelector('label.webyzeProductColorsLabel');
      if (label && label.textContent.indexOf('\u05d1\u05d7\u05e8 \u05e6\u05d1\u05e2') !== -1) label.style.display = 'none';
      if (++tries > 20) clearInterval(iv);
    }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* 5. REMOVED - moving the floating app widgets to <body>.

   This was an attempt to stop the WhatsApp and accessibility buttons from
   drifting into the middle of the screen while scrolling. Re-parenting them
   broke the accessibility widget's own layout (it rendered as a full-width
   blue panel over the footer), so it is gone. The drifting is still open and
   needs to be diagnosed in a real browser: check the widget's offsetParent and
   find which ancestor is creating a containing block for it.
   ------------------------------------------------------------------------- */
